(function () {
  'use strict';

  /* ---------------------------------------------------------------
     "Explore all <category>" after a collection's last product
     sections/collection.liquid prints [data-gd-explore] under the grid.
     Once the last page is showing (opened directly, or loaded by the
     Infinite Scroll app) and the shopper nears the end, this loads the
     collection's View all page (sections/gd-view-all.liquid), drops the
     cards of this collection ([data-gd-own]) and adds the rest of the
     category with the theme's own product cards, so quick shop and lazy
     images work as usual.
  --------------------------------------------------------------- */

  var SECTION_ID = 'gd-explore';

  /* Each page adds its own page numbers (the Infinite Scroll app appends
     them, hidden); the newest one has no "next" link on the last page. */
  function lastPageShowing() {
    var bars = document.querySelectorAll('.pagination');
    var last = bars[bars.length - 1];
    return !last || !last.querySelector('.next a, a[rel="next"]');
  }

  /* Collections that are in no View all category, so they are not fetched again. */
  function noCategory(url, value) {
    try {
      var key = 'gdExploreNone:' + url;
      if (value) window.sessionStorage.setItem(key, '1');
      return window.sessionStorage.getItem(key) === '1';
    } catch (e) {
      return false;
    }
  }

  /* The View all section's id (template--…__main) is remembered after the
     first full-page load, so later loads fetch only that section. */
  function storageKey() {
    var theme = window.Shopify && window.Shopify.theme && window.Shopify.theme.id;
    return 'gdExploreSection:' + (theme || '');
  }

  function remembered(value) {
    try {
      if (value === undefined) return window.sessionStorage.getItem(storageKey());
      if (value) window.sessionStorage.setItem(storageKey(), value);
      else window.sessionStorage.removeItem(storageKey());
    } catch (e) {}
    return null;
  }

  function fetchViewAll(url, retried) {
    var sectionId = retried ? null : remembered();
    var request = sectionId ? url + '&section_id=' + encodeURIComponent(sectionId) : url;

    return fetch(request, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var viewAll = doc.querySelector('[data-gd-va]');
        if (!viewAll) throw new Error('no view all section');
        var wrapper = viewAll.closest('.shopify-section');
        if (!sectionId && wrapper && wrapper.id) remembered(wrapper.id.replace('shopify-section-', ''));
        return wrapper;
      })
      .catch(function (error) {
        if (sectionId && !retried) {
          remembered(null);
          return fetchViewAll(url, true);
        }
        throw error;
      });
  }

  function removeCard(card) {
    var marker = card.previousElementSibling;
    if (marker && marker.classList.contains('easylockdown-item-selector')) marker.remove();
    card.remove();
  }

  function show(box, wrapper) {
    var viewAll = wrapper && wrapper.querySelector('[data-gd-va]');
    var group = viewAll && viewAll.getAttribute('data-gd-group');
    if (!group) {
      noCategory(box.getAttribute('data-url'), true);
      return box.remove();
    }

    Array.prototype.forEach.call(viewAll.querySelectorAll('[data-gd-own]'), removeCard);
    Array.prototype.forEach.call(wrapper.querySelectorAll('.page-title, .breadcrumbs, .collection-header, p.empty'), function (el) {
      el.remove();
    });
    if (!viewAll.querySelector('.product-list-item')) return box.remove();

    wrapper.id = 'shopify-section-' + SECTION_ID;
    /* Other listeners (EComposer) read this editor attribute on section load. */
    wrapper.setAttribute('data-shopify-editor-section', JSON.stringify({ id: SECTION_ID, type: 'gd-view-all' }));
    Array.prototype.forEach.call(wrapper.querySelectorAll('[data-section-id]'), function (el) {
      el.setAttribute('data-section-id', SECTION_ID);
    });

    var heading = document.createElement('h2');
    heading.className = 'page-title';
    heading.textContent = (box.getAttribute('data-heading') || 'Explore all [category]').replace('[category]', group);
    viewAll.parentNode.insertBefore(heading, viewAll);

    if (box.hasAttribute('data-gd-empty')) {
      var section = box.closest('[data-section-type="collection"]') || box.parentNode;
      Array.prototype.forEach.call(section.querySelectorAll('.collection-products > .empty'), function (el) {
        el.remove();
      });
    }

    var node = document.importNode(wrapper, true);
    box.appendChild(node);

    /* Lets the theme set up the new cards (quick shop, lazy images). */
    var event;
    try {
      event = new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: SECTION_ID } });
    } catch (e) {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent('shopify:section:load', true, false, { sectionId: SECTION_ID });
    }
    node.dispatchEvent(event);
  }

  function load(box) {
    if (box.getAttribute('data-gd-explore') === 'loading') return;
    box.setAttribute('data-gd-explore', 'loading');
    fetchViewAll(box.getAttribute('data-url'))
      .then(function (wrapper) { show(box, wrapper); })
      .catch(function () { box.remove(); });
  }

  function init() {
    var box = document.querySelector('[data-gd-explore]');
    if (!box || !window.fetch || !window.DOMParser) return;
    if (noCategory(box.getAttribute('data-url'))) return box.remove();
    if (!('IntersectionObserver' in window)) return lastPageShowing() && load(box);

    var near = false;
    function tryLoad() {
      if (!near || !lastPageShowing()) return;
      observer.disconnect();
      pages.disconnect();
      load(box);
    }
    var observer = new IntersectionObserver(function (entries) {
      near = entries.some(function (entry) { return entry.isIntersecting; });
      tryLoad();
    }, { rootMargin: '0px 0px 1500px 0px' });
    var pages = new MutationObserver(tryLoad);
    observer.observe(box);
    pages.observe(box.parentNode, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
